export function switchExtension(extension) {
	return {
		type: 'SWITCH_EXTENSION',
		extension
	}
}